import Backbone from 'backbone'

const EmailLimitModel = Backbone.Model.extend({
    defaults: {
        count: 0,
        time: null,
    },
    initialize() {
        this.set('time', new Date().getTime())
    },
    allowed() {
        const timeNow = new Date().getTime()
        const count = this.get('count')

        if ((timeNow - this.get('time')) < 60000) {
            return count < 5
        } else {
            this.set('count', 0)
            this.set('time', new Date().getTime())
            return true
        }
    }
})

export default EmailLimitModel
